import React from 'react';
import classnames from 'classnames';
import ReactHtmlParser from "react-html-parser";
import PopupFilledHeader from './popupFilledHeader';

import CrossIcon from '../../img/icons/Cross';

import './modalTitle.scss';
import './modalInner.scss';

class ModalInner extends React.Component {
    render() {
        return (
            <div className={classnames('modal-inner', { 'with-background': localStorage.locales_popup_header_style !== 'filled' })}>
                {this.props.title && (localStorage.locales_popup_header_style === 'standard' ? <>
                    {typeof (this.props.close) === 'function' && <div className="modal-inner-standard">
                        <CrossIcon fill='gray' onClick={() => this.props.close()} />
                    </div>}
                    <div>
                        <div className='modal-title'>
                            {ReactHtmlParser(this.props.title)}
                        </div>
                    </div>
                </> : <PopupFilledHeader title={this.props.title} close={this.props.close} />)}
                <div className={classnames('modal-inner-content', 'with-background')} style={this.props.style}>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default ModalInner;
